import { c as _c } from "react/compiler-runtime";
import { IcoLang16 } from '@onefootprint/icons';
import type { Language } from '@onefootprint/request-types';
import { Select } from '@onefootprint/ui';
import i18n from 'i18next';
const LanguageLabels: Record<Language, string> = {
  en: 'English',
  es: 'Español'
};
const LanguageSelect = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.keys(LanguageLabels);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const allLanguages = t0 as Language[];
  const language = i18n.language as Language;
  const label = LanguageLabels[language];
  if (!label) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = newValue => {
      if (newValue === language) {
        return;
      }
      i18n.changeLanguage(newValue);
      document.documentElement.setAttribute("lang", newValue);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLanguageChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = allLanguages.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Select value={language} onChange={handleLanguageChange} options={t2} size="compact" customTrigger={() => <div className="flex items-center justify-center gap-1 no-underline text-secondary hover:underline hover:underline-offset-2 hover:decoration-2 text-caption-1"><IcoLang16 color="secondary" /><span className="text-caption-1">{language.toUpperCase()}</span></div>} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default LanguageSelect;
function _temp(lng) {
  return {
    value: lng,
    label: LanguageLabels[lng]
  };
}